module.exports = __webpack_public_path__ + "static/media/galeryBaseboards6.314aa328.jpg";